import { MandateFields } from "@/modules/common/utils/zod";
import { PropertyFormFields, PropertyPriceFormFields } from "../utils";
import {
  ListingDescriptionFormFields,
  ResaleDocumentsFormFields,
} from "../utils/listing";

interface ResaleListingMandationFields {
  propertyDetailsMandates?: MandateFields<PropertyFormFields>;
  propertyPriceDetailsMandates?: MandateFields<PropertyPriceFormFields>;
  resaleDocumentsDetailsMandates?: MandateFields<ResaleDocumentsFormFields>;
  listingDescriptionDetailsMandates?: MandateFields<ListingDescriptionFormFields>;
}
export const resaleListingMandatedFields: ResaleListingMandationFields = {
  propertyDetailsMandates: { compound: true, propertyType: true },
  propertyPriceDetailsMandates: {
    paymentType: true,
    // asking price is mandated and handled in the schema for cash payments
    // downpayment and remaining installments are mandated and handled in the schema for installment payments
    // durationRemainingMonths: true,
    // durationRemainingYears: true,
    // installmentFrequency: true,
  },

  resaleDocumentsDetailsMandates: {
    mediaUids: true,
    // floorPlanUids: true,
  },
  listingDescriptionDetailsMandates: {
    descriptionAr: true,
    descriptionEn: true,
  },
};
